import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { governance } from '@/mocks/jiuchou-architecture';

export default function GovernanceLayer() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="第五层 · 平台治理层"
            title="一套完整的平台治理系统"
            subtitle="身份、商品、交易、权益、数据、清分、风控、合规八大治理，体现九畴云铺作为平台的成熟度与可信度。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {governance.map((g, i) => (
            <Reveal key={g.name} delay={i * 60}>
              <div className="h-full p-5 rounded-lg bg-background-100 border border-background-200">
                <div className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center">
                  <i className={`${g.icon} text-secondary-700 text-xl`}></i>
                </div>
                <h3 className="mt-3 font-heading font-bold text-foreground-950">{g.name}</h3>
                <p className="mt-1 text-sm text-foreground-500 leading-relaxed">{g.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}